<!--分期账单列表-->
<template>
  <div>
    <van-row type="flex" >
      <van-col span="16" >
        <van-dropdown-menu active-color="#1989fa">
          <van-dropdown-item v-model="pageInfo.status" :options="conditionCols" @change="orderChange"/>
          <van-dropdown-item v-model="pageInfo.orderType" :options="orderTypes" @change="orderChange"/>
        </van-dropdown-menu>
      </van-col>
      <van-col span="4" ></van-col>
      <van-col span="4">
        <van-nav-bar title="" >
          <van-icon name="cash-back-record" text="重新出账" slot="right" size="20px" @click="openReCalRpt"/>
        </van-nav-bar>
      </van-col>
    </van-row>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="哥哥找过了,没有更多了,爱宝爱宝"
          loading-text="宝不着急,哥哥正在找,嗷呜~"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
      >
        <van-swipe-cell v-for="item in list" :key="item.id">

          <van-cell @click="qryRptDetail(item.id)">

            <!-- 使用 title 插槽来自定义标题 -->
            <template slot="title">
              <van-row type="flex" justify="space-between">
                <van-col span="12" >
                  <span style="font-size: 17px">还款日{{item.repayDate}}</span>
                </van-col>
                <van-col span="5">
                  <van-tag  plain  :type="getStatus(item.status)" style="float: right;margin-top:5px;">{{item.statusName}}</van-tag>
                </van-col>
                <van-col span="7">
                  <span style="font-size: 20px;float: right;">￥{{item.repayAmt}}</span>
                </van-col>
              </van-row>
              <van-row>
                <van-col span="12" >
                  <span> 出账日{{item.acctDate}}</span>
                </van-col>
              </van-row>
              <van-row type="flex" >
                <van-col span="24" >
                  <van-tag  plain round  type="warning" style="margin-top:5px">{{item.payerName}}还款</van-tag>
                  <van-tag  plain round  type="warning" style="margin-top:5px" >{{item.payModeName}}</van-tag>
                </van-col>
              </van-row>
              <van-row type="flex" justify="space-between">
                <van-col span="24" >
                  <span style="float: left;color:#969799;font-size: 12px">{{item.remark}}</span>
                </van-col>

              </van-row>
            </template>

          </van-cell>
          <template slot="right" v-if="item.status == 21100">
            <van-button square plain type="info" text="已还款" class="upd-button" @click="doFinish(item.id)"/>
            <van-button square plain type="warning" text="重新出账" class="upd-button" @click="againReport(item.id)"/>
          </template>
        </van-swipe-cell>
      </van-list>

    </van-pull-refresh>
    <van-popup v-model="popupShow" round closeable position="bottom" :style="{ width: '100%',height: '80%' }" >
      <credit-report-detail-list :rpt-id="rptId"></credit-report-detail-list>
    </van-popup>
    <van-popup v-model="popupRightShow" round  position="right" :style="{ width: '80%',height: '60%' }" >
<!--      -->
      <credit-report-handle @calCredit="getQryData($event)"></credit-report-handle>
    </van-popup>

  </div>

</template>

<script>
import * as MyApi from '../../api/URLApiAddr.js'
import CreditReportDetailList from './CreditReportDetailList.vue'
import CreditReportHandle from "@/components/report/CreditReportHandle";
export default {
  name: 'CreditReport',
  components: {
    CreditReportHandle,
    CreditReportDetailList
  },
  props:{
    qryData:{
      type: Object
    },
    refreshIndex:{
      default: 1,
      type: Number
    }
  },
  data() {
    return {
      list: [],
      error: false,
      loading: false,
      finished: false,
      refreshing: false,
      tagType: "danger",
      pageInfo:{
        current:1,
        size:10,
        total:-1,
        status: 21100,
        orderType: "desc"
      },
      popupShow: false,
      popupRightShow: false,
      rptId: Number,
      conditionCols: [
        { text: '全部', value: null },
        { text: '进行中', value: 21100 },
        { text: '已完成', value: 21101 }
      ],
      orderTypes: [
        { text: '降序', value: 'desc' },
        { text: '升序', value: 'asc' }
      ]
    }
  },
  watch:{
    refreshIndex(){
      this.onRefresh()
    }
  },

  methods: {
    onLoad() {
      if (this.refreshing) {
        this.list = [];
        this.pageInfo.current = 1
        this.pageInfo.total=-1
        this.refreshing = false
      }

      let ths = this
      if(this.list.length == this.pageInfo.total){
        this.finished = true;
        return false
      }
      let params = this.pageInfo
      this.$axios.post(MyApi.QRY_CREDIT_REPORT_LIST,params/*,options*/)
          .then((response) =>  {
            let code = response.code;
            if(code == '200'){
              let data = response.data
              if(data.records.length >0){
                ths.pageInfo.current ++
                //ths.list = data.records
                ths.list = ths.list.concat(data.records)
                ths.pageInfo.total = data.total;
                if(ths.list.length == data.records.total){
                  this.finished = true;
                }
              }else{
                this.finished = true;
              }
            }
            this.loading = false;

          })
          .catch((err) =>{
            this.loading = false
            this.error = true
            this.$toast.fail("数据初始化异常"+err);
          })

    },
    getStatus(status){
      if(status == '21100'){
        return "danger"
      }else{
        return  "primary"
      }
      //return finTypeName
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      this.refreshing = true;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    alterFin(transFinId){
      this.$router.push({ name:'tranceFinanceDetail',params:{transFinId:transFinId} })
    },
    doFinish(creditRptId){
      this.$dialog.confirm({
        title: '已还款',
        message: '确认该分期数据已经还款了吗？'
      }).then(() => {
        let params = {"id":creditRptId}
        this.$axios.post(MyApi.UPD_CREDIT_REPORT_STATUS,params/*,options*/)
            .then((response) =>  {
              debugger
              let code = response.code;
              if(code == '200'){
                this.$toast.success(response.msg);
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
              }
            })
            .catch((err) =>{
              this.$toast.fail("更新异常"+err);
            })

      }).catch(() => {

      });
    },
    qryRptDetail(rptId){
      this.rptId = rptId
      this.popupShow = true
    },
    openReCalRpt(){
      this.popupRightShow = true
    },
    againReport(rptId){
      this.$dialog.confirm({
        title: '重新出账',
        message: '确认该分期数据要进行重新计算出账吗？'
      }).then(() => {
        let params = {"id":rptId}
        this.$axios.post(MyApi.AGAIN_DO_CREDIT_REPORT,params/*,options*/)
            .then((response) =>  {
              debugger
              let code = response.code;
              if(code == '200'){
                this.$toast.success(response.msg);
                // 清空列表数据
                this.finished = false;
                this.refreshing = true;
                // 重新加载数据
                // 将 loading 设置为 true，表示处于加载状态
                this.loading = true;
                this.onLoad();
              }
            })
            .catch((err) =>{
              this.$toast.fail("更新异常"+err);
            })

      }).catch(() => {

      });
    },
    getQryData(qryData) {
      if(qryData){
        this.popupRightShow = false
        this.onRefresh();
      }
    },
    orderChange(){
      this.onRefresh();
    }
  }

}


</script>

<style scoped="scoped">
.upd-button {
  height: 100%;
}
.van-list >>> .van-list__finished-text{
  margin-bottom: 50px;
}


</style>
